import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  collaborators: [],
  route: ''
};

export const payrollSlice = createSlice({
  name: 'payroll',
  initialState,
  reducers: {
    setPayout: (state, action) => {
      for (const key of Object.keys(action.payload)) {
        state[key] = action.payload[key];
      }
    }
  }
});

export const { setPayout } = payrollSlice.actions;
export default payrollSlice.reducer;
